import type { AiBusinessCenterModule } from '../types'

/** 招投标管理独立应用配置。 */
export const biddingModule: AiBusinessCenterModule = {
  key: 'bidding',
  label: '招标投标',
  desc: '看板/主体/项目/公示/文件/投标/保证金/开标/评标/定标/异议/档案/留痕/专家库',
  path: '/bidding',
  homePath: '/bidding/dashboard',
  icon: 'ep:trophy-base',
  color: '#b45309'
}
